import { render, staticRenderFns } from "./chupro.vue?vue&type=template&id=1c9311d6&scoped=true&"
import script from "./chupro.vue?vue&type=script&lang=js&"
export * from "./chupro.vue?vue&type=script&lang=js&"
import style0 from "./chupro.vue?vue&type=style&index=0&id=1c9311d6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c9311d6",
  null
  
)

export default component.exports